import React from 'react'
import { Link } from "react-router-dom";
import ArticlesDashboard from './pages/ArticlesDashboard';

const Articles = () => {
    return ( 
        <>
            <div className="container container-xxl">
            <div className="pagetitle d-flex justify-content-between">
                  <h1>Articles</h1>
                  <div>
                        
                        <Link to="/articles/new" className="btn btn-sm btn-primary">Add Article</Link>
                  </div>
              </div>
            <ArticlesDashboard/>
            </div>
           
              
          
        </>
     );
}
 
export default Articles;